import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LookupDataService } from '../services/lookup-data.service';

@Pipe({
  name: 'gpaSystem',
  pure: true
})
export class GpaSystemPipe implements PipeTransform {
  constructor(private lookupData: LookupDataService) {}

  transform(value: number | string): Observable<string> {
    if (value === null || value === undefined || value === '') {
      return of('نظام GPA غير محدد');
    }
    const id = String(value);
    return this.lookupData.getGpaSystems({
      selectedIds: [id],
      pageNumber: 1,
      pageSize: 1
    }).pipe(
      map(result => {
        const found = result.items.find(m => String(m.id) === id);
        return found ? found.name : 'نظام GPA غير محدد';
      })
    );
  }
}
